import { render } from "./Overlay.vue?vue&type=template&id=581a7777&scoped=true&bindings={}"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"

import "./Overlay.vue?vue&type=style&index=0&id=581a7777&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-581a7777"

export default script